import * as React from "react";
import Link from "next/link";
import Router from "next/router";
import { TinTuc } from "../../models";
import { routing } from "../../const/route";
import Image from "../share/Image";
import tinTuc from "../../models/tinTuc";
import TinTucService from "../../services/tinTuc";
import { DANH_MUC } from "../../const/danh-muc";
import { formatUrlSeo, getIDSeoUrl } from "../../util/seo-url";
import { DanhMucUtil } from "../../util/danhmuc";
import Spinner from '../share/Spinners/Spinners'
import { NEWS } from "../../const/seo-url";
import { loadImage } from "../../util/image";
import Layout from "../share/Layout";
import { PageTransition } from "next-page-transitions";
import SpinnersImageTextNgang from "../share/Spinners/SpinnersImageTextNgang";
import SpinnersImageTextNgangFull from "../share/Spinners/SpinnersImageTextNgangFull";
import Paginate from '../share/Paging'

const SIZE_PER_PAGE = 10;

export interface Props {
  totalTinTuc: number;
  initialPage: number;
  danhSachTinTuc: TinTuc[];
  danhMucId: any;
  tinTucPerPage: number;
  url: any;
}

export interface State { }

export default class TuyenDungList extends React.Component<any, any> {

  page: number = 1
  per_page = 10
  count = 0;

  ten_danh_muc: string;


  constructor(props) {
    super(props);
    this.ten_danh_muc = '';
    this.state = {
      danhSachTinTuc: [],
      loading: false,
      test: '',
    }
  }

  getCurrentPage = () => Number(this.props.initialPage) || 1

  getListTinTuc = page => {
    TinTucService.getsNewsByDanhMucID(
      DANH_MUC.TUYEN_DUNG,
      SIZE_PER_PAGE,
      this.getCurrentPage()
      // page
    ).then(value => {

      this.count = value.count;
      if (value.danh_muc.length === 0) {
        this.setState({
          danhSachTinTuc: [],
          loading: true,
        })
        return
      }
      this.ten_danh_muc = value.danh_muc[0].ten
      if (value && value['tin_tuc'] && value['tin_tuc'].length > 0) {
        value['tin_tuc'].forEach(x => {
          x['url_seo_tin'] = formatUrlSeo(x['url'], x['tin_tuc_id'])
          x['ten_danh_muc'] = DanhMucUtil.getsNameByID(x['danh_muc_tin_id'], x['ten_danh_muc']);
          x['url_seo_danh_muc'] = formatUrlSeo(
            x['ten_danh_muc'],
            x['danh_muc_tin_id']
          )
        })
      }
      this.setState({
        danhSachTinTuc: value['tin_tuc'] || [],
        loading: true,
      })
    });

  }
  componentDidMount() {
    this.getListTinTuc(this.page)
  }
  componentDidUpdate(prevProps) {
    const prevPage = Number(prevProps.initialPage || 1);
    const currentPage = Number(this.props.initialPage || 1);

    if (prevPage !== currentPage) {
      this.page = currentPage;
      this.setState({
        loading: false,
      });
      this.getListTinTuc(currentPage);
    }
  }
  prevPage = () => {
    window.scrollTo(0, 0);
    this.getListTinTuc(--this.page)
  }

  nextPage = () => {
    window.scrollTo(0, 0);
    this.getListTinTuc(++this.page)
  }

  // onPageChange = page => {
  //   window.scrollTo(0, 0);
  //   this.getListTinTuc(page.selected + 1);
  // }

  onPageChange = page => {
    window.scrollTo(0, 0),
    Router.push(
        routing.tinTucPage.routeUrl({ page: page.selected + 1 }),
        routing.tinTucPage.routeUrlAlias({ page: page.selected + 1 })
      );
  };
  render() {
    return (
      <div className="block back-tintuc">
        <div className="container">
          {this.state.loading ? (
            this.state.danhSachTinTuc.length > 0 ? (
              <React.Fragment>
                {this.state.danhSachTinTuc.map(tinTuc => {
                  return <div
                    key={tinTuc.tin_tuc_id}
                    className="row col-sm-12 form-group no-padding-left"
                  >
                    <div className="col-sm-4">

                      <a href={`/${NEWS.TUYEN_DUNG}/${tinTuc.url_seo_tin}`}>
                        <Image className="img-fluid" src={loadImage(tinTuc.hinh_goc)} classPlaceHolder="lazy-image-list" />
                      </a>
                    </div>
                    <div className="col-sm-8 text-justify nopadding">

                      <a href={`/${NEWS.TUYEN_DUNG}/${tinTuc.url_seo_tin}`} className="title_news">{tinTuc.tieu_de}</a>
                      <br /> {tinTuc.mo_ta}
                    </div>
                    <br />
                  </div>
                }

                )}
              </React.Fragment>
            ) : <div className="col-md-12">Tin tức đang cập nhật</div>
          ) : (<SpinnersImageTextNgangFull type={'placeholde'} loading={true} />)}

          {/* {+this.count > +SIZE_PER_PAGE ? (
            <div className="row eve-paging">
              <div className="sortPagiBar col-lg-9">
                <div className="bottom-pagination">
                  <nav>
                    <div
                      className="btn-group mr-2 float-right"
                      role="group"
                      aria-label="First group"
                    >
                      {this.page == 1 ? (
                        <button
                          type="button"
                          className="btn btn-paging disabled"
                        >
                          {'Previous page'}
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-paging"
                          onClick={() => this.prevPage()}
                        >
                          {'Previous page'}
                        </button>
                      )}
                                            &nbsp;
                        {+this.count < +SIZE_PER_PAGE
                        || (Math.ceil(this.count / SIZE_PER_PAGE) == this.page) ? (
                        <button
                          type="button"
                          className="btn btn-paging disabled"
                        >
                          {'Next page'}
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-paging"
                          onClick={() => this.nextPage()}
                        >
                          {'Next page'}
                        </button>
                      )}
                    </div>
                  </nav>
                </div>
              </div>

            </div>
          ) : (
            <div></div>
          )} */}

        </div>
        <div className="container">
          {+this.count > +this.per_page ? (
            <div className="text-center">
              <Paginate
                onPageChange={this.onPageChange}
                total={this.count}
                perPage={SIZE_PER_PAGE}
                initialPage={this.getCurrentPage()}
              />
            </div>
          ) : null}
        </div>
      </div>


    );
  }


}
